export enum SharingRequestStatus {
	NOT_EXIST = 404,
	FORBIDDEN = 403,
	INVALID = 400,
	ALREADY_SHARED = 302
}